import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
              )}
              {!isLast && (
                <span className="flex h-3 w-3 items-center justify-center text-foreground-300">
                  <i className="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}